import {
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import {
  FROST,
  Pill,
  Reveal,
  Section,
  TEAL,
  TEAL_DARK,
  TEAL_LIGHT,
} from "./utils";
import { reasons } from "./data";
import { FaMeh } from "react-icons/fa";

const Problem = () => (
  <Section bg="white" id="problem">
    <VStack gap={10}>
      <Reveal>
        <VStack gap={3} textAlign="center" maxW="560px" mx="auto">
          <Pill>Ismerős?</Pill>
          <Heading
            fontSize={{ base: "xl", md: "2xl" }}
            color={TEAL_DARK}
            letterSpacing="-0.02em"
          >
            Miért nem működnek hatékonyan a hagyományos módszerek?
          </Heading>
          <Text color="gray.500" lineHeight={1.7}>
            A telefonos vagy üzenetes időpontfoglalás időigényes, figyelmet
            igényel, és visszahívást jelent. Az ügyfél várakozik, a szolgáltató
            elérhetetlen – mindenki frusztrált.
          </Text>
        </VStack>
      </Reveal>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap={4} w="full">
        {reasons.map((r, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <HStack
              align="start"
              gap={3}
              p={5}
              bg={FROST}
              borderRadius="xl"
              border="1px solid"
              borderColor="gray.100"
              h="full"
              _hover={{ bg: `${TEAL}06`, borderColor: TEAL_LIGHT }}
              transition="all 0.2s"
            >
              <Icon
                as={FaMeh}
                color="yellow.400"
                boxSize={4}
                mt={0.5}
                flexShrink={0}
              />
              <Text fontSize="sm" color="gray.600" lineHeight={1.65}>
                {r}
              </Text>
            </HStack>
          </Reveal>
        ))}
      </SimpleGrid>
    </VStack>
  </Section>
);

export default Problem;
